import { render } from "./PaywallDash.vue?vue&type=template&id=79678f39&scoped=true"
import script from "./PaywallDash.vue?vue&type=script&lang=js"
export * from "./PaywallDash.vue?vue&type=script&lang=js"

import "./PaywallDash.vue?vue&type=style&index=0&id=79678f39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79678f39"]])

export default __exports__